import { MobileSignInQrCodeDialogComponent } from './components/mobile-sign-in-qr-code-dialog/mobile-sign-in-qr-code-dialog.component';
import { MobileSignInSessionItemComponent } from './components/mobile-sign-in-session-item/mobile-sign-in-session-item.component';
import { MobileSignInSessionListComponent } from './components/mobile-sign-in-session-list/mobile-sign-in-session-list.component';
import { SharedModule } from '../../shared.module';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { QrCodeComponent } from './components/mobile-sign-in-qr-code-dialog/qr-code/qr-code.component';

@NgModule({
  imports: [
    CommonModule,
    SharedModule
  ],
  declarations: [
    MobileSignInSessionListComponent,
    MobileSignInSessionItemComponent,
    MobileSignInQrCodeDialogComponent,
    QrCodeComponent
  ],
  exports: [
    MobileSignInSessionListComponent
  ]
})
export class MobileSignInModule { }
